import cookie from 'cookie';
const extractError = (err) => {
    const error = err.status ? err.err : err;
    if (error && Array.isArray(error.errors))
        return error.errors[0];
    return error;
};
export const extractErrorMessage = (err) => {
    const error = extractError(err);
    return err.message || error.code || JSON.stringify(err);
};
// whitelist of cookies to be read from the incomming request from the browser
const PLAY_READ_COOKIES = [
    'auth',
    'gzgt_',
    'howtank_uuid',
    'JSESSIONID',
    'MEM_ID',
    'pm_cnil_optin',
    'pm_mobile',
    'pmcookies',
    'pmup',
    'ref',
    'rgpd',
    'tag_capping',
    'IS_CONNECTED',
    'NEXT_LOCALE',
    'MP',
    'mfa',
    'rads',
];
// whitelist of cookies to be set on the request (API call) to the backend
const PLAY_SET_COOKIES = [
    'MEM_ID',
    'pm',
    'pm_cnil_optin',
    'pmcookies',
    'tag_capping',
    'IS_CONNECTED',
    'authentication', // Send by selws containing JWT token
    'pmup',
    'pm_mobile',
    'auth',
    'ref',
    'gzgt_',
    'NEXT_LOCALE',
    'MP',
    'rads',
];
export const playSetCookies = () => {
    return PLAY_SET_COOKIES;
};
const playReadCookies = () => {
    return PLAY_READ_COOKIES;
};
export const convertHeadersToIncomingHttpHeaders = (headers) => {
    const incomingHttpHeaders = {};
    headers.forEach((value, key) => {
        incomingHttpHeaders[key.toLowerCase()] = value;
    });
    return incomingHttpHeaders;
};
export const extractHeadersForWs = (requestHeaders) => {
    if (requestHeaders && requestHeaders.cookie) {
        const requestCookies = cookie.parse(requestHeaders.cookie);
        // we only keep a subset of cookies (already parse into an object by cookie-parser)
        const toKeep = playReadCookies();
        const cookies = [];
        toKeep.forEach((item) => {
            if (requestCookies[item]) {
                cookies.push(cookie.serialize(item, requestCookies[item]));
            }
        });
        const headers = { cookie: cookies.join('; ') };
        if (typeof requestHeaders['rfr-type'] !== 'undefined') {
            headers['rfr-type'] = requestHeaders['rfr-type'];
        }
        if (typeof requestHeaders['user-agent'] !== 'undefined') {
            headers['user-agent'] = requestHeaders['user-agent'];
        }
        if (typeof requestHeaders['X-Forwarded-For'] !== 'undefined') {
            if (typeof window === 'undefined') {
                // only on server #FED-675
                headers['X-Forwarded-For'] = requestHeaders['X-Forwarded-For'];
            }
        }
        if (typeof requestHeaders['user-language'] !== 'undefined') {
            headers['user-language'] = requestHeaders['user-language'];
        }
        if (typeof requestHeaders['marketplace'] !== 'undefined') {
            headers['marketplace'] = requestHeaders['marketplace'];
        }
        return headers;
    }
    return undefined;
};
export const extractParamsForWs = (requestParams) => {
    const headers = {};
    if (requestParams) {
        if ('partnerId' in requestParams) {
            headers['X-Rakuten-Partner-Id'] = requestParams.partnerId;
        }
        if ('partnerId' in requestParams) {
            headers['X-Rakuten-Partner-Token'] = requestParams.partnerToken;
        }
    }
    return headers;
};
